import { Network } from 'jamespot-front-business';
import { JRCAvatarProps, SROnly } from 'jamespot-react-components';
import { useIntl } from 'react-intl';
import styled, { useTheme } from 'styled-components';
import { useAppSelector } from '../redux/store';
import { commonComponentsRegistry } from '../registry/CommonRegistry';

const JRCIcon = commonComponentsRegistry.getLazyComponent('Icon');
const JRCAvatar = commonComponentsRegistry.getLazyComponent('JRCAvatar');

const BASE_MULTIPLE = 8;

const SR = styled.span`
    ${SROnly}
`;

export const Avatar = (props: JRCAvatarProps) => {
    const theme = useTheme();
    const intl = useIntl();
    const networkPublic = useAppSelector(Network.selectors.selectNetworkPublic);

    if (props.uri === networkPublic?.uri) {
        return (
            <>
                <JRCIcon
                    name={'icon-fs-wall'}
                    size={(props.size ?? 3) * BASE_MULTIPLE}
                    color={theme.color.primary}
                    variant={'circle'}
                />
                <SR>{intl.formatMessage({ id: 'NETWORK_Public' })}</SR>
            </>
        );
    }

    return <JRCAvatar {...props} />;
};
